import { Badge, IconButton, Theme, Tooltip } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { cloudDeploymentTypeIconMap } from '../../../elements/AppFlow/utils/cloud-deployment-utils';
import { CloudSubType, CloudTypes } from '../../types/artifacts-type';
import { getCloudSubTypeIconType } from '../../utils/artifacts-utils';

const ArtifactCloudCell: FC<
  React.PropsWithChildren<ArtifactCloudCellProps>
> = ({ cloudType, cloudSubType, url }) => {
  const { classes } = useStyles();
  const CloudTypeIcon = cloudDeploymentTypeIconMap.get(cloudType);
  const CloudSubTypeIcon = getCloudSubTypeIconType(cloudSubType);

  return (
    <Tooltip title={`${cloudType} ${cloudSubType}`}>
      <div className={classes.artifactCodeCell}>
        {CloudSubTypeIcon && (
          <Badge
            badgeContent={
              CloudTypeIcon && (
                <IconButton
                  size='small'
                  target='_blank'
                  href={url}
                  style={{ backgroundColor: 'transparent' }}>
                  <CloudTypeIcon className={classes.subIcon} />
                </IconButton>
              )
            }
            overlap='circular'
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}>
            <IconButton
              size='small'
              target='_blank'
              href={url}
              style={{ backgroundColor: 'transparent' }}>
              <CloudSubTypeIcon className={classes.mainIcon} />
            </IconButton>
          </Badge>
        )}
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactCodeCell: {
    display: 'inline-flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },
  mainIcon: {
    width: 'auto',
    height: '1em',
  },
  subIcon: {
    width: 'auto',
    height: '1em',
  },
}));

export interface ArtifactCloudCellProps {
  cloudType: CloudTypes;
  cloudSubType: CloudSubType;
  url: string;
}

export default ArtifactCloudCell;
